import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type ShareIconProps = IconProps;

export const ShareIcon = forwardRef<SVGSVGElement, ShareIconProps>(
  function ShareIcon(props: ShareIconProps, ref) {
    return (
      <Icon
        data-testid="ShareIcon"
        aria-label="share"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path d="M10 4a2 2 0 1 0-1.956-1.581L3.509 4.687a2 2 0 1 0 0 2.626l4.535 2.268a2 2 0 1 0 .448-.894L3.957 6.419a1.992 1.992 0 0 0 0-.838l4.535-2.268C8.859 3.734 9.399 4 10 4zm1 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM3 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm8-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
      </Icon>
    );
  }
);
